import { useNavigate, useLocation } from "react-router-dom";
import { Compass, ArrowLeft, LayoutGrid } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-background text-foreground grid place-items-center px-6" data-testid="not-found-page">
      <div className="max-w-md w-full text-center">
        <div className="h-14 w-14 rounded-xl bg-primary/10 text-primary grid place-items-center mx-auto mb-5">
          <Compass className="h-7 w-7" />
        </div>
        <div className="font-display text-5xl font-extrabold tracking-tight">404</div>
        <h1 className="text-lg font-semibold mt-2">This page could not be found</h1>
        <p className="text-sm text-muted-foreground mt-2 break-all">
          We couldn't find <span className="font-mono">{location.pathname}</span>. It may have moved, or the link is incorrect.
        </p>
        <div className="flex items-center justify-center gap-2 mt-6">
          <Button variant="outline" className="gap-2" data-testid="notfound-back" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-4 w-4" /> Go back
          </Button>
          <Button className="gap-2" data-testid="notfound-home"
            onClick={() => navigate(user ? "/labs" : "/")}>
            <LayoutGrid className="h-4 w-4" /> {user ? "HMG Training Labs" : "Home"}
          </Button>
        </div>
      </div>
    </div>
  );
}
